import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import {
    calculateLifetimeDepositAmount,
    calculateMonthlyDepositAmount,
    calculateNumberOfUnitsFromLifetimeDepositAmount,
    calculateNumberOfUnitsFromMonthlyDepositAmount,
    calculateNumberOfUnitsFromYearlyDepositAmount,
    calculateYearlyDepositAmount, stateWithPlan2AsPrimary
} from "../Utils/PlanUtils";

const useUpdateUnitsBasedOnDeposit = (state) => {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (state.quote.quoteBasedOn === 'deposit') {
            let calculateFunction = calculateNumberOfUnitsFromMonthlyDepositAmount;
            if (state.quote.depositFrequency === 'A') {
                calculateFunction = calculateNumberOfUnitsFromYearlyDepositAmount;
            } else if (state.quote.depositFrequency === 'T') {
                calculateFunction = calculateNumberOfUnitsFromLifetimeDepositAmount;
            }
            state.setPlan(prevData => ({
                ...prevData,
                numberOfUnits: calculateFunction(state, state.plan.depositAmount)
            }));
        }
        debugLog("useUpdateUnitsBasedOnDeposit");
    }, [
        state.quote.quoteBasedOn,
        state.quote.depositFrequency,
        state.plan.depositAmount,
        state.plan.depositMode,
        state.plan.depositCode,
        state.plan.completionInsurance,
        state.plan.nomineeInsurance,
        state.plan.criticalIllnessInsurance
    ]);



    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (state.quote2.quoteBasedOn === 'deposit') {
            let calculateFunction = calculateNumberOfUnitsFromMonthlyDepositAmount;
            if (state.quote2.depositFrequency === 'A') {
                calculateFunction = calculateNumberOfUnitsFromYearlyDepositAmount;
            } else if (state.quote2.depositFrequency === 'T') {
                calculateFunction = calculateNumberOfUnitsFromLifetimeDepositAmount;
            }
            state.setPlan2(prevData => ({
                ...prevData,
                numberOfUnits: calculateFunction(stateWithPlan2AsPrimary(state), state.plan2.depositAmount)
            }));
        }
        debugLog("useUpdateUnitsBasedOnDeposit");
    }, [
        state.quote2.quoteBasedOn,
        state.quote2.depositFrequency,
        state.plan2.depositAmount,
        state.plan2.depositMode,
        state.plan2.depositCode,
        state.plan2.completionInsurance,
        state.plan2.nomineeInsurance,
        state.plan2.criticalIllnessInsurance
    ]);
}

export default useUpdateUnitsBasedOnDeposit;